import React, { useState } from 'react';
import './AgencyDetails.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';

const AgencyDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const agencyDetails = location.state?.agencyDetails || null;
  const [formData, setFormData] = useState({

    name: agencyDetails.name || '',
    address: agencyDetails.address || '',
    email: agencyDetails.email || '',
    organization: agencyDetails.organization || '',
    mobile: agencyDetails.mobile || '',
    siteName: agencyDetails.siteName || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const updateTask = async () => {
    try {
      const response = await axios.put(API_URL + `/agency/${agencyDetails.name}`, formData);

      if (response.status === 200) {
        console.log('Agency details updated successfully');
        window.alert('Agency details updated successfully!')
        navigate('/SiteDatabase')
      } else {
        console.error('Error updating user');
      }
    } catch (error) {
      console.error(error);
    }
  };


return( 
<div>
    <SideMenuBar></SideMenuBar>
        
    <div class="content">
        <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Agency Database</h3>  
          </div>

          <div className='row4_AgencyDetails'>
            <h3 className='siteName_h3_AgencyDetails'>{agencyDetails.siteName}</h3>
          </div>

          <div class="row5_AgencyDetails">
            <div class="row5_column1_AgencyDetails">
              <p>Agency Name</p>
              <input className='agencyName_input_AgencyDetails' placeholder='Agency Name' name='name'
              value={formData.name}
              onChange={handleInputChange}></input>

              <p>Address</p>
              <textarea className='address_input_AgencyDetails' placeholder='Address' name='address'
              value={formData.address}
              onChange={handleInputChange}></textarea><br/>

            </div>
  
            <div class="row5_column2_AgencyDetails">
              <p>Organization</p>
              <input className='organization_input_AgencyDetails' placeholder='Organization' name='organization'
              value={formData.organization}
              onChange={handleInputChange}></input>

              <p>Phone No.</p>
              <input className='phoneNo_input_AgencyDetails' placeholder='Phone No.' name='mobile'
              value={formData.mobile}
              onChange={handleInputChange}></input>

              <p>Email ID</p>
              <input className='role_input_AgencyDetails' placeholder='Email ID' name='email'
              value={formData.email}
              onChange={handleInputChange}></input>

              <button className='update_btn_input_AgencyDetails' onClick={updateTask}>Update</button>
            </div>
          </div>  
          
    </div>
</div>
 )
}

export default AgencyDetails;